import { render } from "./RoomPlayer.vue?vue&type=template&id=1dad5716"
import script from "./RoomPlayer.vue?vue&type=script&lang=js"
export * from "./RoomPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__